import Url from "@core/scripts/helper/url";
import fetchWithCSRF from "@core/scripts/helper/fetch-with-csrf";

function get() {
    const url = Url.toAbsolute('/ajax/fit-finder/');
    return fetchWithCSRF(url)
        .then(toJsonOrThrow(new Error("response was not okay")))
}

function toJsonOrThrow(error) {
    return (response) => {
        if(response.ok) {
            return response.json();
        }
        throw error;
    };
}

export default {
    get
}
